export default {
    FETCH_ONE_SCORE: "FETCH_ONE_SCORE",
    RESET_ONE_SCORE: "RESET_ONE_SCORE"
}